import { render, staticRenderFns } from "./TravelsAndVehiclesEmissionsBar.vue?vue&type=template&id=04963fe5"
import script from "./TravelsAndVehiclesEmissionsBar.vue?vue&type=script&lang=js"
export * from "./TravelsAndVehiclesEmissionsBar.vue?vue&type=script&lang=js"
import style0 from "./TravelsAndVehiclesEmissionsBar.vue?vue&type=style&index=0&id=04963fe5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports